__turbopack_context__.v({
  "logoCreditflowresearch": "styles-module-scss-module__dDv14G__logoCreditflowresearch",
});
